/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBrandCypress = createSolidComponent("brand-cypress", "IconBrandCypress", [
  [
    "path",
    {
      d: "M19.48 17.007a9 9 0 1 0 -7.48 3.993c.896 0 1.691 -.573 1.974 -1.423l3.526 -10.577"
    }
  ],
  ["path", { d: "M13.5 9l2 6" }],
  ["path", { d: "M10.764 9.411a3 3 0 1 0 -.023 5.19" }]
]);

export { IconBrandCypress as default };
//# sourceMappingURL=IconBrandCypress.js.map
